import { Pipe, PipeTransform } from "@angular/core";
import { isObject } from "../../../node_modules/ionic-angular/util/util";

@Pipe({
  name: "translate",
})
export class TranslatePipe implements PipeTransform {
  public transform(value: any) {
    if (!value) { return null; }

    if (isObject(value)) {
      return !(value.en === "") ? value.en : value.es;
    } else {
      return value;
    }
  }
}



// WEBPACK FOOTER //
// ./src/pipes/translate/translate.ts